<template>
    <!-- Tarjeta de un bloque: título, ayuda (qué mide) y "basado en X de Y intakes". -->
    <section class="es-card" :aria-label="titulo">
        <header class="es-card-h">
            <div>
                <h3>{{ titulo }}</h3>
                <p v-if="base" class="es-base" :class="{ 'is-poco': poco }">
                    <template v-if="base.total">Basado en <b>{{ cifra(base.con) }}</b> de {{ cifra(base.total) }} intakes ({{ pct }}%)<template v-if="poco"> · muestra chica</template></template>
                    <template v-else>Sin intakes con estos filtros</template>
                </p>
                <!-- Por qué faltan: de qué canal vienen los intakes sin el dato. -->
                <p v-if="motivos.length" class="es-faltan">
                    <span>Sin el dato:</span>
                    <span v-for="m in motivos" :key="m.k" class="es-faltan-i" :class="{ 'is-todo': m.todos }">
                        <b>{{ cifra(m.n) }}</b> {{ m.t }}<template v-if="m.todos"> · no lo trae</template>
                    </span>
                </p>
                <p v-else-if="sub" class="es-base">{{ sub }}</p>
            </div>
            <slot name="acciones" />
            <button v-if="ayuda" type="button" class="es-ayuda" :class="{ 'is-open': verAyuda }" :aria-label="'Qué mide: ' + titulo" :aria-expanded="String(verAyuda)" @click="verAyuda = !verAyuda" @blur="verAyuda = false">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
                <span class="es-ayuda-t" role="tooltip">{{ ayuda }}</span>
            </button>
        </header>
        <slot />
    </section>
</template>

<script>
export default {
    name: 'EstCard',
    props: { titulo: { type: String, required: true }, ayuda: { type: String, default: '' }, base: { type: Object, default: null }, sub: { type: String, default: '' } },
    data() { return { verAyuda: false }; },
    computed: {
        pct() { return this.base && this.base.total ? Math.round(this.base.con * 100 / this.base.total) : 0; },
        // "Muestra chica" es solo cuando hay pocos casos para sacar conclusiones,
        // no cuando falta el dato en muchos intakes (eso lo explica `motivos`).
        poco() { return !!this.base && this.base.total > 0 && this.base.con < 30; },
        // Se muestra si falta el dato en al menos el 10 % de los intakes.
        motivos() {
            const b = this.base;
            if (!b || !b.total || !Array.isArray(b.faltan) || (b.total - b.con) / b.total < 0.1) return [];
            return b.faltan.filter(m => m.n > 0).map(m => ({ ...m, t: m.t.charAt(0).toLowerCase() + m.t.slice(1), todos: m.n === m.de }));
        },
    },
    methods: { cifra(n) { return Number(n || 0).toLocaleString('es-CL'); } },
};
</script>
